import { useContext } from "react";
import AppContext from "../../AppContext";
import { useDispatch } from "react-redux";
import { setToggleWidget } from "../../widgetSlice";
import {
  removeAllMessages,
  resetBot,
  resetMessageState,
  setUserTypingPlaceholder,
  toggleBotTyping,
  toggleUserTyping,
} from "../Messages/messageSlice";
import { Icon } from "./Icons";
import PropTypes from "prop-types";
import botAvatar1 from "./../../../assets/mona-mascot-temp.png";

const dropdownMenu = [
  {
    title: "Close",
  },
  {
    title: "Restart",
  },
  {
    title: "Clear Chat",
  },
];

export const Header = ({ onLogout }) => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const {
    botSubTitle,
    botTitle,
    chatHeaderCss,
    rasaServerUrl,
    userId,
    metadata,
  } = appContext;

  const { textColor, backgroundColor, enableBotAvatarBorder } = chatHeaderCss;

  const handleCloseButton = () => {
    dispatch(setToggleWidget(false));
  };

  const handleClearChatButton = () => {
    dispatch(removeAllMessages());
    dispatch(toggleBotTyping(false));
    dispatch(toggleUserTyping(true));
    dispatch(setUserTypingPlaceholder("Type your message..."));
  };
  const handleRestartButton = () => {
    dispatch(resetMessageState());
    dispatch(
      resetBot({
        rasaServerUrl,
        message: "/restart",
        sender: userId,
        metadata,
        onLogout,
      })
    );
  };
  return (
    <>
      <div
        className="h-15 relative flex cursor-default items-center space-x-4 rounded-t-[1.8rem]  p-1 shadow-lg drop-shadow"
        style={{ backgroundColor, color: textColor }}
      >
        <div
          className="my-2 ml-2 shrink-0 rounded-full border-[1px] p-2"
          style={{
            borderColor: textColor,
            borderWidth: enableBotAvatarBorder,
            backgroundColor: "white",
          }}
        >
          <img style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid #d4e0ee",
          }} src={botAvatar1} alt="Bot Logo" />
        </div>
        <div className="w-full ">
          <div className="text-xl font-semibold antialiased">{botTitle}</div>
          <p className="">{botSubTitle}</p>
        </div>
        <div style={{ display: "flex", gap: "1rem", marginRight: "5px" }}>
          <div style={{ cursor: "pointer" }} onClick={handleClearChatButton}>
            <Icon name={"Clear Chat"} />
          </div>
          <div style={{ cursor: "pointer" }} onClick={handleCloseButton}>
            <Icon name={"Close"} />
          </div>
        </div>
      </div>
    </>
  );
};

Header.propTypes = {
  onLogout: PropTypes.func.isRequired,
};
